import { useTheme } from '../context/ThemeContext';
import { Music, DollarSign, Upload, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/AboutPage.css';

const About = () => {
  const { darkMode } = useTheme();

  return (
    <div className={`about-container ${darkMode ? 'dark' : ''}`}>
      <section className="about-hero">
        <div className="container">
          <h1>About Falphin</h1>
          <p className="lead">Fair, transparent music distribution built for artists who value their independence.</p>
        </div>
      </section>

      <section className="mission">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>
                Falphin was founded in 2024 with a simple goal: to provide musicians and labels with straightforward, 
                affordable music distribution without the fine print. We believe artists should keep more of what they earn 
                and maintain control over their creative work.
              </p>
              <p>
                In an industry often criticized for complex contracts and hidden fees, we're building a different kind of 
                distribution platform—one that respects both your art and your business.
              </p>
            </div>
            <div className="mission-values">
              <div className="value-card">
                <DollarSign size={24} />
                <h3>Fair Pricing</h3>
                <p>One-time payment. No subscriptions. No hidden costs. Keep 100% of your royalties.</p>
              </div>
              <div className="value-card">
                <Upload size={24} />
                <h3>Lasting Access</h3>
                <p>Upload your music once—it stays live forever with no renewal fees or additional charges.</p>
              </div>
              <div className="value-card">
                <Shield size={24} />
                <h3>Total Control</h3>
                <p>You own your music. We're just here to help you distribute it to the world's top platforms.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-falphin">
        <div className="container">
          <h2>Why We're Different</h2>
          <div className="difference-grid">
            <div className="difference-item">
              <div className="difference-icon">
                <Music size={32} />
              </div>
              <div>
                <h3>Built by Musicians, for Musicians</h3>
                <p>
                  Our team understands the challenges of the modern music industry because we've lived them. 
                  We've created the distribution service we wish existed when we were starting out.
                </p>
              </div>
            </div>
            
            <div className="difference-item">
              <div className="difference-icon">
                <DollarSign size={32} />
              </div>
              <div>
                <h3>Transparent Pricing</h3>
                <p>
                  No confusing tiers or surprise fees. What you see is what you pay—once. 
                  Your music stays up without requiring continuous payments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-about">
        <div className="container">
          <h2>Ready to Distribute Your Music?</h2>
          <p>Join artists who've taken control of their music distribution.</p>
          <Link to="/pricing" className="cta-button primary">
            View Pricing
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
